export enum CreateRectificationFlowEnum {
  USUAL = 'usual',
  REPAIR = 'repair',
}
